<script>
import { defineComponent } from '@vue/composition-api';
import Loader from '../Loader.vue';

export default defineComponent({
  components: {
    Loader,
  },
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    icon: {
      type: String,
      default: () => '',
    },
    iconIsText: {
      type: Boolean,
      default: () => false,
    },
    isMain: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      default: () => '',
    },
    subtitle: {
      type: String,
      default: () => '',
    },
    preSubtitle: {
      type: String,
      default: () => '',
    },
    posSubtitle: {
      type: String,
      default: () => '',
    },
    tooltipText: {
      type: String,
      default: () => null,
    },
    smallCaption: {
      type: String,
      default: () => '',
    },
  },
});
</script>

<template>
  <v-layout
    row
    align="center"
    class="mb-4"
  >
    <v-flex xs2>
      <v-avatar
        size="31pt"
        color="#FFADDE"
      >
        <span
          v-if="iconIsText"
          class="avatar"
        >
          {{ icon }}
        </span>
        <v-icon
          v-else
          size="19px"
          style="color: #140C22"
        >
          {{ icon }}
        </v-icon>
      </v-avatar>
    </v-flex>
    <v-flex xs10>
      <p
        v-if="!loading"
        :class="isMain ? 'title-main' : 'title'"
      >
        {{ title }}
      </p>
      <Loader
        v-else
        :size="20"
        :width="3"
        :center="false"
        class="title"
      />
      <p :class="isMain ? 'subtitle-main' : 'subtitle'">
        <strong>{{ preSubtitle }}</strong> {{ subtitle }} <strong> {{ posSubtitle }}</strong>
        <v-tooltip
          v-if="tooltipText"
          top
        >
          <template #activator="{ on, attrs }">
            <v-btn
              flat
              icon
              small
              v-bind="attrs"
              class="subtitle__help-button"
              color="black"
              v-on="on"
            >
              <v-icon :size="15">
                mdi-help-circle
              </v-icon>
            </v-btn>
          </template>
          <span>{{ tooltipText }}</span>
        </v-tooltip>
      </p>
      <p v-if="smallCaption" class="mt-2 small-caption">
        {{ smallCaption }}
      </p>
    </v-flex>
  </v-layout>
</template>
<style lang="scss" scoped>
.avatar {
  color: white;
  font-size: 20px;
  font-weight: 900;
}
.title {
  margin: 0;
  font-family: 'Nunito Sans' !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 18px !important;
  line-height: 25px;
}
.subtitle-main {
  margin: 0;
  font-family: 'Nunito Sans';
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  &__help-button {
      margin: 0;
      margin-left: -7px;
  }
}
.title-main {
  margin: 0;
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 800;
  font-size: 22px;
}
.subtitle {
  margin: 0;
  font-family: 'Nunito Sans';
  font-style: normal;
  font-size: 12px;
  line-height: 16px;
  &__help-button {
      margin: 0;
      margin-left: -4px;
      margin-bottom: 2px;
  }
}
.small-caption {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 14px;
    color: #959595;
}
.v-avatar {
  border-radius: 30%;
}
</style>
